module.exports = __webpack_public_path__ + "fonts/poppins-medium-webfont.1fd3af4b.woff";